import { useClientExperiment } from '../hooks/use-client-experiment';
import { useExperiment } from '../hooks/use-experiment';

export function usePLPRedesignExperiment() {
  const experiment = useExperiment();
  return experiment?.ab_plp_redesign_2025;
}

/**
 * This hook uses a feature flag to determine if set of analytics events should fire for a segment of the test group in the PLP Redesign AB Test 2025.
 */
export function useExperimentalSegmentEvents(key: string) {
  const enabled = !!usePLPRedesignExperiment();
  return useClientExperiment(key, { enabled });
}
